export default {
	name: 'ModalMixin',
	props: {
		options: {
			type: Object,
			required: false,
			default: () => {
			}
		},
		isAbsolute: {
			type: Boolean,
			default: false
		}
	},
	created () {
		this.lockBodyScroll(!this.isAbsolute)
	},
	beforeDestroy () {
		this.lockBodyScroll(false)
	},
	methods: {
		lockBodyScroll (value = true) {
			try {
				if (!process.client) {
					return
				}

				document.body.style.overflow = value ? 'hidden' : ''
			} catch (e) {
			}
		},

		async onClose () {
			if (this.options.cancelCallback) {
				await this.options.cancelCallback()
			}

			this.$emit('close')
		},
		async onConfirm (data) {
			if (this.options.confirmCallback) {
				await this.options.confirmCallback(data)
			}

			this.$emit('close')
		}
	}
}
